// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SurveyIdListRequestModel {
    static getAttributeTypeMap() {
        return SurveyIdListRequestModel.attributeTypeMap;
    }
}
SurveyIdListRequestModel.discriminator = undefined;
SurveyIdListRequestModel.additionalProperties = false;
SurveyIdListRequestModel.attributeTypeMap = [
    {
        "name": "ids",
        "baseName": "ids",
        "type": ""
    },
];
//# sourceMappingURL=surveyIdListRequestModel.js.map